const custom = {
  gameoo: {
    searchPlaceholder: "Recherche ...",
    consumeVoucher: "Enregister récompense ...",
    newVoucher: "Nouvelle récompense ...",
    locationSelectPlaceholder:
      "Veuillez sélectionner une ville pour choisir un emplacement",
    entityTypeSelectPlaceholder: "Sélectionnez un type d'entité",
    consumeVoucherTitle: "Enregistrer une récompense",
    consumeSuccess: "Code envoyé avec succès ✅ : %{pseudo} et %{code}",
    consumeCancel: "Annuler",
    consumeValidate: "Valider",
    consumeVoucherInstruction: "Référence du voucher à consommer :",
    consumeVoucherInstructionPseudo: "Le pseudo du joueur :",
    consumeVoucherInstructionInvoiceAmount: "Montant de la facture :",
    statsVoucherLabel: "Synthèse",
    statsBogoLabel: "BOGO",
    statsDiscountLabel: "Réduction sur addition",
    statsFreeProductLabel: "Produits offerts",
    statsGiftCardLabel: "Bon d'achat",
    dashboard: {
      voucherConsumedTitle: "Récompenses consommées par type",
    },
    voucherThumbnailPlaceHolder:
      "Glissez-déposez une image (JPG, JPEG, PNG – max 1 Mo), ou cliquez pour sélectionner",
  },
};

export default custom;
